import React from 'react'
import { Container } from 'react-bootstrap';
import FormSec from "./Form";

const ContactSection = () => {
    const columnWidth = 3;
  return (
    <section className="contact-sec">
        <div className="contact-form-section py-5">
        <Container>
            <div className='contact-bg'>
                <FormSec columnWidth={columnWidth} />            
            </div>
        </Container>
        </div>
    </section>
  )
}

export default ContactSection